// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-id-cell[data-v-49cddf23] {
  display: flex;
  align-items: center;
  gap: 6px;
}
.global-id-cell a[data-v-49cddf23]:hover {
  text-decoration: none;
}
.global-id-cell__warning-label a[data-v-49cddf23] {
  color: #fd7e14;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
